import { render } from "./setting-button.vue?vue&type=template&id=fcf729c0"
import script from "./setting-button.vue?vue&type=script&lang=js"
export * from "./setting-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__